module.exports = __webpack_public_path__ + "media/images/balance-prosperity-ebitda-f2d6f3ccaab5ff2a2b65a31481dcb106.png";